/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeReportMappingOutcomeRequest, type ErrorResponse, type InternalErrorResponse, type ReportMappingOutcomeRequest } from '../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/data-imports/suggest-mappings/{runId}/outcome
 */
export interface OutcomeRequestBuilder extends BaseRequestBuilder<OutcomeRequestBuilder> {
    /**
     * Call when the admin starts an import whose mapping step was pre-filled by SuggestImportMappings. Send each suggested column's header and the target it is finally mapped to (null when left unmapped). Each column is recorded as kept, changed, cleared, created (the proposed attribute or price tier was created and used) or mapped by hand where no field was suggested. Columns the suggestions did not cover are ignored, and a later report for the same run replaces an earlier one. Nothing about the import itself changes; this only measures how good the suggestions were.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: ReportMappingOutcomeRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * Call when the admin starts an import whose mapping step was pre-filled by SuggestImportMappings. Send each suggested column's header and the target it is finally mapped to (null when left unmapped). Each column is recorded as kept, changed, cleared, created (the proposed attribute or price tier was created and used) or mapped by hand where no field was suggested. Columns the suggestions did not cover are ignored, and a later report for the same run replaces an earlier one. Nothing about the import itself changes; this only measures how good the suggestions were.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: ReportMappingOutcomeRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const OutcomeRequestBuilderUriTemplate = "{+baseurl}/api/data-imports/suggest-mappings/{runId}/outcome";
/**
 * Metadata for all the requests in the request builder.
 */
export const OutcomeRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: OutcomeRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeReportMappingOutcomeRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
